import { Toaster } from "react-hot-toast";
import { toastTheme } from "../hooks/useToast";

function ToastProvider() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      toastOptions={toastTheme}
    />
  );
}

export default ToastProvider;
